// Libraries
import { Injectable } from '@angular/core';
import { Angular2TokenService } from 'angular2-token';
import { DomSanitizer } from '@angular/platform-browser';
// Interfaces
import { ApiConfig } from './../../../woopa-ui/api/config/api-config';
import { QRInformation } from './../interfaces/qr-information.interface';

// Models
import {
  CheckObjectType
} from '../models/object-type.interface';

/**
 * `PositionService` could get `Position` data from anywhere that implements an api RESTFUL.
 */
@Injectable()
export class QRService {
  /**
   * Current api url.
   */
  protected apiUrl: string;

  /**
   * Creates a new `QRService` instance.
   * @param httpService Http service to make requests.
   */
  constructor(
    private sanitizer: DomSanitizer,
    protected _tokenService: Angular2TokenService,
    protected _apiConfig: ApiConfig
  ) {
    this.apiUrl = 'api/v' + _apiConfig.version + '/qrs';
  }

  // Public methods
  /**
   * Get QR image
   * @param QRUrl QR image url
   * @returns An promise with the image
   */
  public get(qrInformation: QRInformation): Promise<any> {
    return this._tokenService.get(this.apiUrl + this.getQRUrl(qrInformation))
      .toPromise()
      .then(response => this.processData(response as any))
      .catch( this.handleError );
  }

  /**
   * Proccess response data from api request.
   * @param res Response object
   * @returns An JSON object.
   */
  protected processData(res: Response): any {
    // Obtain base 64 url
    return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + res.text());
  }

  /**
   * Catch api request errors.
   * @param error Request error.
   * @returns Promise with error message.
   */
  protected handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  /**
   * Get QR url
   * @author Leandro Diaz <leandro.diaz@woopasoft.com>
   * @param  {QRInformation} qrInformation QR information
   * @return {string} QR URL with object type
   */
  private getQRUrl(qrInformation: QRInformation): string {
    let qrUrl = '';
    if (qrInformation.isPosition) {
      // There is a position
      qrUrl += '/positions';
    } else {
      // Check object type
      if (CheckObjectType.isExtinguisher(qrInformation.objectTypeId)) {
        qrUrl += '/extinguishers';
      } else if (CheckObjectType.isAlarm(qrInformation.objectTypeId)) {
        qrUrl += '/alarms';
      } else if (CheckObjectType.isHydrant(qrInformation.objectTypeId)) {
        qrUrl += '/hydrants';
      } else if (CheckObjectType.isPushButton(qrInformation.objectTypeId)) {
        qrUrl += '/push_buttons';
      } else if (CheckObjectType.isSiren(qrInformation.objectTypeId)) {
        qrUrl += '/sirens';
      } else if (CheckObjectType.isSmokeDetector(qrInformation.objectTypeId)) {
        qrUrl += '/smoke_detectors';
      } else if (CheckObjectType.isSectionalValve(qrInformation.objectTypeId)) {
        qrUrl += '/sectional_valve';
      }
    }
    return qrUrl + '/' + qrInformation.id;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/services/qr.service.ts